import React from "react";

function SeenStatus({ seenBy = [], deliveredTo = [] }) {

  // 🔵 Seen (receiver ne dekh liya)
  if (seenBy.length > 1) {
    return <span style={{ color: "#0d6efd" }}>✓✓</span>;
  }

  // ✓✓ Delivered (receiver tak pahunch gaya)
  if (deliveredTo.length > 0) {
    return <span>✓✓</span>;
  }

  // ✓ Sent (server tak gaya)
  return <span>✓</span>;
}

export default SeenStatus;